import { Response, Patient } from 'typings/entities/patients';

export const patients = ({ data }: { data: Response }): Response => data;

export const patient = ({ data }: { data: Patient }): Patient => data;
